import cookie from 'react-cookies';

export const saveCookie = (name, value, options = {}) => cookie.save(name, value, options);

export const deleteCookie = name => cookie.remove(name);

export const getCookie = value => cookie.load(value);
